import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { applicationStore } from "../../store/ApplicationStore";
import { useNavigate } from "react-router-dom";
import UploadProcessingWithAnimationComponent from "src/components/UploadProcessingWithAnimationComponent";
import { useTranslation } from "react-i18next";
import { IdentificationTypes } from "src/enums/IdentificationTypes";

const ProcessingId = observer(() => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleSubmit = async () => {
        verificationStepComplete(applicationStore.verificationSteps.activeStep);

        navigate("/next", { replace: true })

    }
    const verificationStepComplete = (key) => {
        switch (key) {
            case IdentificationTypes.RESIDENCE_PERMIT:
                applicationStore.setVerificationSteps({ ...applicationStore.verificationSteps, isCompletedResidencePermit: true });
                return;
            case IdentificationTypes.IDENTITY_CARD:
                applicationStore.setVerificationSteps({ ...applicationStore.verificationSteps, isCompletedIdCard: true });
                return;
            case IdentificationTypes.PASSPORT:
                applicationStore.setVerificationSteps({ ...applicationStore.verificationSteps, isCompletedPassport: true });
                return;
            case IdentificationTypes.DRIVER_LICENSE:
                applicationStore.setVerificationSteps({ ...applicationStore.verificationSteps, isCompletedDriverLicence: true });
                return;
            default:
                break;
        }
    }

    useEffect(() => {
        if (applicationStore.documentSurface.front && applicationStore.documentSurface.back) {
            applicationStore.setDocumentSurface({ front: false, back: false });
            handleSubmit();
        }
    }, [])
    return (
        <UploadProcessingWithAnimationComponent
            title={t('processingId.title')}
            message={t('processingId.message')}
        />
    )
})

export default ProcessingId
